import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXSiteHomeDisableIDX implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxSiteHomeDisableIDXContainer";
    }
    render(){
        // console.log("site home disable idx");

    }
}